export default __webpack_public_path__ + "static/service_banner_shape-829f6637184dedcc2193d951ae032099.png";